(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scheduledJob', {
                parent: 'admin',
                url: '/scheduledJobs',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                    pageTitle: 'uniromaLandingApp.scheduledJob.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduledJob/scheduledJobs.html',
                        controller: 'ScheduledJobController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledJob');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scheduledJob.detail', {
                parent: 'admin',
                url: '/scheduledJob/{id}',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                    pageTitle: 'uniromaLandingApp.scheduledJob.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-detail.html',
                        controller: 'ScheduledJobDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledJob');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduledJob', function($stateParams, ScheduledJob) {
                        return ScheduledJob.get({id : $stateParams.id});
                    }]
                }
            })
            .state('scheduledJob.new', {
                parent: 'scheduledJob',
                url: '/new',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-dialog.html',
                        controller: 'ScheduledJobDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    dateStart: null,
                                    dateEnd: null,
                                    status: null,
                                    jobName: null,
                                    newRecords: null,
                                    changedRecords: null,
                                    deletedRecords: null,
                                    identicalRecords: null,
                                    rejectedRecords: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('scheduledJob', null, { reload: true });
                    }, function() {
                        $state.go('scheduledJob');
                    })
                }]
            })
            .state('scheduledJob.edit', {
                parent: 'scheduledJob',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-dialog.html',
                        controller: 'ScheduledJobDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledJob', function(ScheduledJob) {
                                return ScheduledJob.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('scheduledJob', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('scheduledJob.delete', {
                parent: 'scheduledJob',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DASHBOARD_PROVISIONING']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduledJob/scheduledJob-delete-dialog.html',
                        controller: 'ScheduledJobDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduledJob', function(ScheduledJob) {
                                return ScheduledJob.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduledJob', null, { reload: 'scheduledJob' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
